import { get } from "lodash";

export const withDocumentsCompletion = (additionalInfo, isCompleted) => {
  const current = additionalInfo || {};
  if (isCompleted) {
    return {
      ...current,
      isDocumentsCompleted: true,
      documentsCompletedAt:
        get(current, "documentsCompletedAt") || new Date().toISOString(),
    };
  }
  return {
    ...current,
    isDocumentsCompleted: false,
    documentsCompletedAt: null,
    completeDocsReminderSentAt: null,
  };
};

export const JUSTIFICATION_STEPS = {
  ADHERENT: "ADHERENT",
  SPOUSE: "SPOUSE",
  CHILDREN: "CHILDREN",
};

// Must stay aligned with the "Parcours acoris" transitions on
// fields.hasRelatedPersons: adherent -> spouse -> children -> recap.
export const isLastJustificationStep = (step, hasRelatedPersons) => {
  const hasSpouse = Boolean(get(hasRelatedPersons, "hasSpouse"));
  const hasChildren = Boolean(get(hasRelatedPersons, "hasChildren"));
  if (step === JUSTIFICATION_STEPS.CHILDREN) return true;
  if (step === JUSTIFICATION_STEPS.SPOUSE) return !hasChildren;
  return !hasSpouse && !hasChildren;
};
